import {
  contentAdaptiveStyles,
  fillTheHeight,
  media
} from '@anm/styles/helpers';
import styled from 'styled-components';

const DaysContainerWrapperMobile = media.tablet`
    flex-direction: column;
`;

const DaysContainerWrapper = styled.div`
  ${fillTheHeight};
  ${DaysContainerWrapperMobile};
  padding: 45px 30px 50px;
  ${contentAdaptiveStyles};
`;

export default DaysContainerWrapper;
